export class InaccessibleDataLocation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "reason",
            "baseName": "reason",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InaccessibleDataLocation.attributeTypeMap;
    }
    constructor() {
    }
}
